module.exports = __webpack_public_path__ + "static/alley-hunter-c033550d1d313cba8f0c53c91d916fd5.png";